import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, FileSearch, Building2, History, Network, Download, Sparkles, Brain, LogOut,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testId: "nav-dashboard" },
  { to: "/opportunities", label: "Opportunities", icon: FileSearch, testId: "nav-opportunities" },
  { to: "/ai-filter", label: "AI Filter", icon: Brain, testId: "nav-ai-filter" },
  { to: "/sources", label: "Sources", icon: Network, testId: "nav-sources" },
  { to: "/buyers", label: "Priority Buyers", icon: Building2, testId: "nav-buyers" },
  { to: "/runs", label: "Crawl Runs", icon: History, testId: "nav-runs" },
  { to: "/exports", label: "Exports", icon: Download, testId: "nav-exports" },
];

export const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <aside
      className="fixed left-0 top-0 h-screen w-60 border-r border-zinc-200 bg-[#FAFAFA] flex flex-col z-30"
      data-testid="app-sidebar"
    >
      <div className="px-5 py-5 border-b border-zinc-200">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-[#002FA7] flex items-center justify-center">
            <Sparkles size={16} className="text-white" />
          </div>
          <div>
            <div className="font-bold text-sm tracking-tight leading-tight font-[Chivo]">
              PROCURE / CA
            </div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
              RFP Intelligence
            </div>
          </div>
        </div>
      </div>
      <nav className="flex-1 px-2 py-3">
        {NAV.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 text-sm transition-colors rounded-sm mb-0.5 ${
                isActive
                  ? "bg-zinc-900 text-white"
                  : "text-zinc-700 hover:bg-zinc-100"
              }`
            }
          >
            <Icon size={16} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-zinc-200 px-4 py-3">
        <div className="text-[10px] uppercase tracking-widest text-zinc-400 font-mono">
          v1.0 · Canada Only
        </div>
        <div className="text-xs text-zinc-600 mt-1">
          HR · Payroll · ERP · Oracle · SAP · K-12
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-3 py-2 text-xs text-zinc-500 hover:text-red-600 transition-colors mt-2 w-full"
        >
          <LogOut size={14} />
          Sign Out
        </button>
      </div>
    </aside>
  );
};
